export default {
    client: {
        NoPrivie: {
            title: 'Client Management',
            description: 'One-stop management and configuration of application access channels. Real-time monitoring of online status, setting intelligent agent trigger, reply, and other strategies on the channel side, configuring the binding relationship between group chats and intelligent agents.',
            dialogStrategyConfiguration: 'Dialog Strategy Configuration',
            dialogStrategyConfigurationDescription: 'Channel-based app/workflow configuration',
            dialogStrategyConfigurationDescription2: 'Smart conversations in private & group chats',
            dialogStrategyConfigurationDescription3: 'Voice recognition & voice replies',
            offlineMonitoringNotification: 'Offline Monitoring Notification',
            offlineMonitoringNotificationDescription: 'Real-time agent status monitoring',
            offlineMonitoringNotificationDescription2: 'Instant offline email notifications',
            offlineMonitoringNotificationDescription3: 'Reliable AI service uptime',
            webPageConfiguration: 'Web Page Configuration',
            webPageConfigurationDescription: 'Customizable embedded chat widget styling',
            webPageConfigurationDescription2: 'Page-specific floating window exclusion',
            webPageConfigurationDescription3: 'Image, voice input & manual handoff support',
        },
        clientManagement: 'Clients',
        offlineNotification: 'Offline Notification',
        pleaseEnter: 'search client name',
        webEmbed: 'Web Embed',
        pleaseSelectType: 'select client type',
        pleaseSelectDeployType: 'select deploy type',
        selfBuild: 'Self-built',
        hosting: 'Hosting',
        upgrade: 'Upgrade',
        pleaseSelectStatus: 'select client status',
        offline: 'Offline',
        online: 'Online',
        query: 'Search',
        icon: 'Icon',
        type: 'Type',
        status: 'Status',
        operation: 'Operations',
        deployType: 'Deploy Type',
        lastActiveTime: 'Last Active Time',
        login: 'Login',
        configuration: 'Configure',
        edit: 'Edit',
        delete: 'Delete',
        chat: 'Chat',
        clientEdit: 'Client Edit',
        clientName: 'Client Name',
        pleaseEnterClientName: 'Enter client name',
        isEnabled: 'Is Enabled',
        notificationChannel: 'Notification Channel',
        SMS: 'SMS',
        WECHAT_MP: 'WECHAT_MP',
        scanQrcode: 'Scan Qrcode',
        scanSuccess: 'Scan Success',
        pleaseSelectNotificationChannel: 'Please select the notification channel',
        setSuccess: 'Set Success',
        openSuccess: 'Open Success',
        closeSuccess: 'Close Success',
        editSuccess: 'Edit Success',
        editFail: 'Edit Fail',
        deleteChannel: 'Delete Client',
        deleteChannelDescription: 'Are you sure you want to delete this client?',
        deleteChannelSuccess: 'Delete Channel Success',
        deleteChannelFail: 'Delete Channel Fail',
        save: 'Save',
        back: 'Back',
        isEnabledConfiguration: 'Is Enabled Configuration',
        isEnabledConfigurationDescription: 'Enable to use remote configuration, disable to use local configuration',
        applicationConfiguration: 'Application',
        dialogApplication: 'Agent / Workflow',
        dialogApplicationDescription: 'Dialog default used LinkAI application or workflow',
        selectYourGlobalApplication: 'Select your global application',
        groupChatApplicationMapping: 'Group Agent Mapping',
        groupChatApplicationMappingDescription: 'Different group chats and LinkAI application mapping',
        inputGroupChatName: 'Input Group Chat Name',
        selectAIApplication: 'Select AI Application',
        add: 'Add',
        singleChat: 'Single Chat',
        triggerPrefix: 'Trigger Prefix',
        triggerPrefixDescription: 'Messages containing this prefix can trigger robot replies, corresponding to the configuration single_chat_prefix',
        replyPrefix: 'Reply Prefix',
        replyPrefixDescription: 'The prefix that the robot will carry when replying, corresponding to the configuration single_chat_reply_prefix',
        pleaseEnterReplyPrefix: 'Please enter the reply prefix',
        selectYourReplyMode: 'Please select your reply mode',
        welcomeWords: 'Welcome Words',
        welcomeWordsDescription: 'Welcome words automatically sent when users follow the public account',
        pleaseEnterWelcomeWords: 'Please enter the welcome words',
        groupChat: 'Group Chat',
        groupChatPrefix: 'Trigger Prefix',
        groupChatPrefixDescription: 'Messages containing this prefix can trigger robot replies, corresponding to the configuration group_chat_prefix',
        groupChatReplyPrefix: 'Reply Prefix',
        groupChatReplyPrefixDescription: 'The prefix that the robot will carry when replying, corresponding to the configuration group_chat_reply_prefix',
        botName: 'Bot Name',
        botNameDescription: 'When using the robot in a group chat, you need to configure the robot name, which is the name of the Feishu application',
        pleaseEnterBotName: 'Please enter the robot name',
        blackAndWhiteList: 'Black and White List',
        groupNameWhiteList: 'Group Name White List',
        groupNameWhiteListDescription: 'Group chat name configuration here to trigger automatic replies, corresponding to the configuration group_name_white_list',
        pleaseEnterGroupName: 'Please enter the group chat name',
        userBlackList: 'User Black List',
        userBlackListDescription: 'Users in this blacklist will not be replied to, corresponding to the configuration nick_name_black_list',
        pleaseEnterUserBlackList: 'Please enter the user name',
        voice: 'Voice',
        openVoiceRecognition: 'Voice Recognition',
        voiceRecognitionDescription: 'Enable to recognize voice messages as text',
        replyMode: 'Reply Mode',
        replyModeDescription: 'Choose when to reply to voice messages',
        drawPicture: 'Draw Picture',
        imageModel: 'Image Model',
        drawPictureDescription: 'Choose the model for text-to-image', 
        selectYourImageModel: 'Select your image model',
        triggerPicturePrefix: 'Trigger Picture Prefix',
        otherConfiguration: 'Other Config',
        adminPassword: 'Admin Password',
        adminPasswordDescription: 'Used to authenticate admin commands, authentication method: #auth password',
        pleaseEnterAdminPassword: 'Please enter your password',
        streamCardOutput: 'Stream Card Output',
        streamCardOutputDescription: 'Support DingTalk AI card effect, see',
        dingTalkOpenPlatform: 'DingTalk Open Platform',
        cardTemplateId: 'Card Template ID',
        goTo: 'Go To',
        createCardTemplateAndCopyTemplateId: 'Create Card Template and Copy Template ID',
        pleaseEnterCardTemplateId: 'Please enter the card template ID',
        authorizationConfiguration: 'Authorization',
        callbackAddress: 'Callback Address',
        botInviteLink: 'Bot Invite Link',
        copy: 'Copy',
        pleaseEnterYour: 'Please enter your',
        replyStrategy: 'Reply Strategy',
        manualIntervention: 'Manual Intervention',
        manualInterventionDescription: 'After manual reply,',
        seconds: 'seconds, AI does not reply',
        voiceReplyVoice: 'Voice Reply Voice',
        alwaysReplyVoice: 'Always Reply Voice',
        noReplyVoice: 'No Reply Voice',
        copySuccess: 'Copy Success',
        all: 'All',
        application: 'Agents',
        flowwork: 'Workflows',
        submitAndPushToClient: 'After submission, it will be pushed to the client and take effect. Do you want to submit?',
        submit: 'Submit',
        saveSuccess: 'Save Success',
        cancelSave: 'Cancel Save',
        addAccount: 'Add Account',
        privateChat: 'Private Chat',
        pleaseSelectApplicationOrFlowwork: 'Please select the application/flowwork',
        open: 'Open',
        openGroupCount: 'Open Group Count ',
        isOpen: 'Is Open',
        close: 'Close',
        syncGroupChat: 'Sync Group Chat',
        groupChatAvatar: 'Group Chat Avatar',
        groupChatName: 'Group Chat Name',
        cancelGroupChat: 'Cancel Group Chat',
        selectProtocol: 'Select Protocol',
        ipadScanCode: 'ipad Scan Code',
        pcScanCode: 'PC Scan Code',
        selectArea: 'Select Area',
        pleaseSelectProvince: 'Please select the province',
        pleaseSelectCity: 'Please select the city',
    
        generateQrCode: 'Generate Qr Code',
        loginQrCode: 'Login Qr Code',
        pleaseScanCodeAndWait: 'Please scan the code and wait patiently',
        ifPromptInputVerificationCode: 'If the prompt input verification code, please click',
        inputVerificationCode: 'Input Verification Code',
        pleaseEnterVerificationCode: 'Please enter the verification code',
        submitSuccess: 'Submit Success',
        pleaseSelectProtocol: 'Please select the protocol',
        switchSuccess: 'Switch Success',
        switchFail: 'Switch Fail, Please Try Again',
        isOpenApplicationBinding: 'Is Open Application Binding?',
        bindApplication: 'Bind Application',
        hostingSuccess: 'Hosting Success',
        hostingFail: 'Hosting Fail, Please Try Again',
        cancelBinding: 'Cancel Binding',
        loginSuccess: 'Login Success',
        loginException: 'Login Exception',
        syncGroupChatSuccess: 'Sync Group Chat Success',
        pleaseSelectAppCode: 'Please Select App Code',
        confirmCloseApplication: 'Are you sure you want to close this application?',
        closeApplication: 'Close Application',
        closeFail: 'Close Fail, Please Try Again',
        cancelOperation: 'Cancel Operation',
        pleaseBindApplication: 'Please Bind Application',
        pleaseCloseAiReply: 'Please Close Ai Reply',
        confirmCancelGroupChat: 'Are you sure you want to cancel the group chat? After cancellation, you need to synchronize the group chat again to use it',
        cancelGroupChat1: 'Cancel Group Chat',
        cancelSuccess: 'Cancel Success',
        privateChatConfiguration: 'Private Chat Configuration',
        groupChatConfiguration: 'Group Chat Configuration',
        groupChatNotConfigured: 'Group chat is not configured separately, use the global configuration',
        triggerConditions: 'Trigger Conditions',
        allReply: 'All Reply',
        atReply: '@Reply',
        conditionsReply: 'Conditions Reply',
        conditionsSetting: 'Conditions Setting',
        conditionsSettingDescription: 'When the user\'s question satisfies the set condition combination, AI can reply',
        aiNotReplyDescription: 'After the human replies on the channel side',
        pleaseEnter1: 'Please enter',
        voiceSetting: 'Voice Setting',
        voiceQuestion: 'Voice Question',
        voiceReply: 'Recognize the voice message of the friend for reply',
        voiceReplyDescription: 'Recognize voice messages in group chats for replies (independent of the trigger condition settings for text questions)',
        triggerPrefixWord: 'Trigger Prefix Word',
        triggerPreFrom: {
            description1: 'The prefix word of the voice message is the same as the prefix word set, AI can reply',
            description2: 'Can set multiple prefix words, input after confirmation',
            description3: 'If not set, the default is that all voice messages trigger AI replies',
        },
        addPrefixWord: 'Input content after enter to complete addition',
        addPrefixWordDescription: 'Input content after enter to add prefix word',
        voiceReply1: 'Voice Reply',
        voiceReplyDescription1: 'Convert AI reply content to voice message',
        voiceSelect: {
            onlyReplyVoice: 'Only reply voice when voice question',
            alwaysReplyVoice: 'Always reply voice',
        },
        addFriendWelcome: 'Add Friend Welcome',
        groupChatWelcome: 'Group Chat Welcome',
        noWelcomeMsg: 'No Welcome Msg',
        fixedWelcomeMsg: 'Fixed Welcome Msg',
        aiWelcomeMsg: 'AI Welcome Msg',
        welcomeSetting: 'Welcome Setting',
        insertVariable: 'Insert Variable',
        welcomeStyle: {
            title: 'Welcome Style Setting',
            single: 'Use prompt words to set AI welcome words, and insert variables to add user nicknames, such as "Please welcome the user to add you as a friend and explain that they can ask you anytime"',
            group: 'Use prompt words to set AI welcome words, and insert variables to add group names and user nicknames, such as "Please welcome the user to enter the group and explain that they can ask you anytime"',
        },
        addConfiguration: 'Add Configuration',
        deleteConfiguration: 'Delete Configuration',
        welcomeNewUser: 'Welcome new user {{nick_name}} to the group chat! Feel free to @ me with any questions.',
        welcomeNewFriend: 'Welcome, new friend {{nick_name}}! Feel free to ask me anything.',
        welcomeNewUser1: 'Please welcome the user to add you as a friend and explain that they can ask you anytime',
        welcomeNewFriend1: 'Please welcome the user to enter the group and explain that they can ask you anytime',
        welcomeNewUser2: 'to the group chat! Feel free to @ me with any questions.',
        welcomeNewFriend2: 'to enter the group and explain that they can ask you anytime',
        userNickName: 'User Nickname',
        confirmDeleteGroupConfiguration: 'Are you sure you want to delete the group configuration? After deletion, the group chat global configuration will be used.',
        confirmDeleteConfiguration: 'Confirm Delete Configuration',
        deleteSuccess: 'Delete Success',
        cancelDelete: 'Cancel Delete',
        and: 'And',
        or: 'Or',
        question: 'Question',
        condition: 'Condition',
        value: 'Value',
        addConditions: 'Add Conditions',
        conditions: 'Conditions',
        operator: {
            contains: 'Contains',
            not_contains: 'Not Contains',
            eq: 'Equal',
            neq: 'Not Equal',
            pre_contains: 'Pre Contains',
            post_contains: 'Post Contains',
        },
        IbotConfig: {
            baseSetting: 'Base Setting',
            setYourWebsiteBaseInfo: 'Set your website base information',
            websiteName: 'Name',
            websiteNameDescription: 'When used as a standalone page link, the website name will be displayed in the browser tab',
            pleaseEnterIntegrateName: 'Enter the integrate name',
            dialogApplication: 'Agent',
            pleaseSelectDialogApplication: 'Eelect the Agent',
            windowTitle: 'Window Title',
            pleaseEnterWindowTitle: 'Enter the window title',
            windowSubTitle: 'Window Subtitle',
            pleaseEnterWindowSubTitle: 'Enter the window subtitle',
            welcomeWords: 'Welcome Words',
            welcomeWordsDescription: 'This is the first message sent by the intelligent assistant to the user when the dialog is first entered, supports Markdown format. ',
            forExample: 'Support the use of "[]" symbols to generate guide questions, such as ',
            forExample1: 'I am your intelligent assistant, you can ask me ',
            forExample2: '- [How to plan an event?]',
            forExample3: 'Application first sentence. e.g. What can I help you with?',
            inputBoxPrompt: 'Placeholder',
            pleaseEnter: 'Please enter',
            disablePage: 'Disable Page',
            disablePageDescription: 'When embedded using a floating window, you can set pages that do not need to display the floating window',
            add: 'Add',
            serialNumber: 'Index',
            disablePageAddress: 'Disable Page Address',
            operation: 'Operation',
            delete: 'Delete',
            backgroundColor: 'Background Color',
            voiceInput: 'Voice Input',
            voiceInputDescription: 'After opening, users can use voice input to chat in the dialog window',
            clearRecord: 'Clear Record',
            clearRecordDescription: 'After opening, users can manually clear the history of the dialog window and retain the context memory',
            integrationMethod: 'Integration Method',
            viewIntegrationMethod: 'View Integration Method',
            methodOne: 'Method One ',
            floatingWindow: 'Floating Window Embedding',
            methodTwo: 'Method Two ',
            pageLink: 'Independent Page Link',
            methodThree: 'Method Three ',
            iframe: 'Iframe Embedding',
            copyScript: 'Copy the script tag content, place it in the <head> tag of the application project root path html file',
            copy: 'Copy',
            advancedSetting: 'Advanced Setting',
            professionalFunction: 'Team Function, see',
            versionDescription: 'Version Description',
            setPersonalizedIconAndTransferToHuman: 'Set personalized icon and transfer to human',
            setPersonalizedIconAndTransferToHumanDescription: 'Set the button style of the floating window expand/collapse button in the floating window embedded mode',
            floatingIcon: 'Floating Icon',
            floatingIconDescription: 'Set the button style of the floating window expand/collapse button in the floating window embedded mode',
            uploadFile: 'Upload File',
            uploadFileDescription: 'Suggest uploading images without background color, recommended size 48*48px, jpg, png format',
            backToDefault: 'Restore Default',
            botHeadImage: 'Bot Head Image',
            noShowHeadImage: 'No Show',
            uploadFile1: 'Upload File',
            uploadFile1Description: 'Suggest uploading images without background color, recommended size 36*36px, jpg, png format',
            bottomIcon: 'Bottom Icon',
            bottomIconDescription: 'Suggest uploading images without background color, recommended size 12*12px, jpg, png format',
            bottomText: 'Bottom Text',
            pleaseEnter20Characters: 'Please enter 20 characters or less',
            jumpAddress: 'Jump Address',
            jumpAddressDescription: 'Click the bottom slogan to jump to the third-party link',
            clickBottomSloganToJumpToThirdPartyLink: 'Click the bottom slogan to jump to the third-party link',
            pleaseEnterUrl: 'Please enter url',
            transferToHuman: 'Transfer to Human',
            transferToHumanDescription: 'After opening, users can actively transfer to human in the dialog window, and can use the "transfer to human" ability in the application configuration',
            needUpgradeToProfessionalVersion: 'Need to upgrade to Team version',
            introduction: 'Introduction',
            applicationFirstSentence: 'Application first sentence. e.g. What can I help you with?',
            confirm: 'Confirm',
            uploadFail: 'Upload Fail',
            pleaseReLogin: 'Please Re-Login',
            imageUploadOnlySupportJpegPngFormat: 'Image upload only supports jpeg,png format',
            imageSizeLessThan5MB: 'Image size must be less than 5MB!',
            copySuccess: 'Copy Success',
            websiteNameRequired: 'Website name is required!',
            bindApplicationRequired: 'Bind application is required!',
            application: 'Agents',
            flowwork: 'Workflows',
        }
    }
};